module.exports = __webpack_public_path__ + "img/desk4.e35fea85.png";